import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
} from '@angular/core'
import { Subject, Subscription, debounceTime } from 'rxjs'

import { TypographyComponent, TypographyVariant } from '@hyperkit'

import { EditorComponent } from '../hyperkit'

@Component({
  selector: 'hunt-details-editor',
  imports: [EditorComponent, TypographyComponent],
  templateUrl: './hunt-editor.component.html',
  styleUrls: ['./hunt-editor.component.scss'],
})
export class HuntEditorComponent implements OnDestroy {
  @Input() public title = ''
  @Input() public variant: TypographyVariant = 'h4'
  @Input() public height: string | number = '250px'
  @Input() public value = ''
  @Output() public valueChange = new EventEmitter<string>()

  /** Subject for raw editor changes */
  private readonly valueSubject = new Subject<string>()

  /** Subscription to emit debounced values */
  private readonly valueSub: Subscription

  /** Last raw value received — used to flush on destroy */
  private lastRawValue: string | null = null

  /** Whether the debounce has fired for the latest raw value */
  private flushed = true

  constructor() {
    this.valueSub = this.valueSubject.pipe(debounceTime(500)).subscribe((v) => {
      this.flushed = true
      this.valueChange.emit(v)
    })
  }

  onEditorValueChange(updatedValue: string): void {
    this.lastRawValue = updatedValue
    this.flushed = false
    this.valueSubject.next(updatedValue)
  }

  ngOnDestroy(): void {
    this.valueSub.unsubscribe()
    // Flush the last value if the debounce hadn't fired yet
    if (!this.flushed && this.lastRawValue !== null) {
      this.valueChange.emit(this.lastRawValue)
    }
  }
}
